import { ICalloutsBanner, ICalloutsBannerVisibilityState } from "@dineout-payment-success-ui/interfaces";
import { getCloudinaryRawUrl, isEmpty } from "@swiggy-private/js-utils";

export const getCalloutsBannerLottieUrl = (lottieId?: string): string => getCloudinaryRawUrl(lottieId || "");

export const getCalloutsBannerVisibilityState = (
    isEventReservation: boolean,
    calloutsBanner?: ICalloutsBanner,
    rewardsPoolWidget?: { imageId: string },
): ICalloutsBannerVisibilityState => ({
    showCalloutsBanner: !isEventReservation && !isEmpty(calloutsBanner),
    showDinecashPoolBanner: !isEventReservation && isEmpty(calloutsBanner) && !isEmpty(rewardsPoolWidget),
});
